import { ContextualHelp, withFlipper } from "lcm-iot-commons";
import { FormattedMessage, useIntl } from "react-intl";

type Props = {
  flipper: {
    ownerVerificationDisabled?: boolean;
  };
};

export function UserProfileCustomersHelp({ flipper }: Props) {
  const intl = useIntl();

  return (
    <ContextualHelp
      title={intl.formatMessage({ id: "user_profile.customers.help.title" })}
    >
      <p>
        <FormattedMessage id="user_profile.customers.help.title.description1" />
      </p>
      {/* feat-NLM-2070, January 2026, temporarily removing this paragraph */}
      {flipper.ownerVerificationDisabled ? null : (
        <p>
          <FormattedMessage id="user_profile.customers.help.title.description2" />
        </p>
      )}
      <h3>
        <FormattedMessage id="user_profile.customers.help.how_to_get_verified.title" />
      </h3>
      <p>
        <FormattedMessage id="user_profile.customers.help.how_to_get_verified.description1" />
      </p>
      <p>
        <FormattedMessage id="user_profile.customers.help.how_to_get_verified.description2" />
      </p>
    </ContextualHelp>
  );
}

export default withFlipper(UserProfileCustomersHelp);
